module.exports = __webpack_public_path__ + "static/media/pencil.4abc339d.svg";